import { Component, OnInit, signal } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLinkActive, RouterLink } from '@angular/router';
import { ToastService } from '@app/core/services/toast.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { UsersService } from 'api/services';
import { lastValueFrom } from 'rxjs';
import { LeftSplitviewComponent } from '../../components/left-splitview/left-splitview.component';
import { MatFormField, MatLabel, MatPrefix, MatError } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { UnauthFooterComponent } from '../../components/unauth-footer/unauth-footer.component';

@UntilDestroy({ checkProperties: true })
@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [
        LeftSplitviewComponent,
        ReactiveFormsModule,
        MatFormField,
        MatLabel,
        MatIcon,
        MatPrefix,
        MatInput,
        MatError,
        MatButton,
        RouterLinkActive,
        RouterLink,
        UnauthFooterComponent,
        TranslateModule,
    ],
})
export class ForgotPasswordComponent implements OnInit {
    passwordResetForm: UntypedFormGroup;
    loading = signal(false);

    constructor(
        private formBuilder: UntypedFormBuilder,
        private router: Router,
        private usersService: UsersService,
        private toastr: ToastService,
        private translateService: TranslateService,
    ) {}

    ngOnInit(): void {
        this.passwordResetForm = this.formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    //  getter to access form field
    get f() {
        return this.passwordResetForm.controls;
    }

    /**
     * sends user email/username to API, which triggers an email with a password reset link
     */
    async onResetPassword() {
        this.loading.set(true);
        try {
            await lastValueFrom(
                this.usersService.putPublicResetUserPassword({
                    body: {
                        emailAddress: this.passwordResetForm.value['email'],
                    },
                })
            );
        } catch (error) {
            this.toastr.error(this.translateService.instant('GENERAL-ERROR'));
        } finally {
            // Timeout for better UX
            setTimeout(() => {
                this.loading.set(false);
            }, 300);
            this.router.navigate(['/check-email']);
        }
    }
}
